import { ZoneType } from "@/types"
import Cookies from "js-cookie"

import { apiFetch } from "../utils"
import { postActivityLog } from "./log"

const billingUrl = `himo-billing/`

export async function getAllZones() {
  const response = await apiFetch(`${billingUrl}zone/?size=25`)

  if (!response.ok) {
    throw new Error("Cannot fetch zones")
  }

  return await response.json()
}
// Used to create a new zone
export async function addZoneType(data: ZoneType) {
  const token = Cookies.get("auth-token")

  if (token) {
    const response = await apiFetch(`${billingUrl}zone/`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
    if (!response.ok) {
      await postActivityLog({
        menu_path: "HIMO Billing-Digos Water District-Zone Settings",
        sub_menu_path: "/zone-settings/zones",
        action: `Add Zone Type (Name ${data.zone_name})`,
        status_code: response.status,
        api_endpoint: response.url,
        web_url: window.location.href,
      })
      // Read response body safely
      let responseBody: any
      try {
        responseBody = await response.json()
      } catch {
        responseBody = await response.text()
      }

      //console.log("%cAPI Error Response", "color: red; font-weight: bold;")
      //console.table({
      //  Status: response.status,
      //  StatusText: response.statusText,
      //  URL: response.url,
      //  OK: response.ok,
      //  Body: responseBody,
      //})

      // Extract the message safely
      let message = "An error occurred."

      if (
        responseBody &&
        typeof responseBody === "object" &&
        "error" in responseBody
      ) {
        message = responseBody.error
      } else if (typeof responseBody === "string") {
        message = responseBody
      }

      // Throw only the readable message
      throw new Error(message)
    }

    await postActivityLog({
      menu_path: "HIMO Billing-Digos Water District-Zone Settings",
      sub_menu_path: "/zone-settings/zones",
      action: `Add Zone Type (Name ${data.zone_name})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    return response.json()
  }

  return null
}

// Used to edit zone
export async function editZoneType(zoneTypeId: number, data: ZoneType) {
  const token = Cookies.get("auth-token")

  if (token) {
    const response = await apiFetch(`${billingUrl}zone/${zoneTypeId}/`, {
      method: "PUT",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
    if (!response.ok) {
      await postActivityLog({
        menu_path: "HIMO Billing-Digos Water District-Zone Settings",
        sub_menu_path: "/zone-settings/zones",
        action: `Edit Zone Type (ID ${zoneTypeId})`,
        status_code: response.status,
        api_endpoint: response.url,
        web_url: window.location.href,
      })

      throw new Error(`Error: ${response.statusText}`)
    }

    await postActivityLog({
      menu_path: "HIMO Billing-Digos Water District-Zone Settings",
      sub_menu_path: "/zone-settings/zones",
      action: `Edit Zone Type (ID ${zoneTypeId})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    return response.json()
  }

  return null
}

// Used to delete or remove zone
export async function deleteZoneType(id: number) {
  const token = Cookies.get("auth-token")

  if (token) {
    const response = await apiFetch(`${billingUrl}zone/${id}/`, {
      method: "DELETE",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    })

    if (!response.ok) {
      await postActivityLog({
        menu_path: "HIMO Billing-Digos Water District-Zone Settings",
        sub_menu_path: "/zone-settings/zones",
        action: `Delete Zone Type (ID ${id})`,
        status_code: response.status,
        api_endpoint: response.url,
        web_url: window.location.href,
      })

      throw new Error(`Error: ${response.statusText}`)
    }

    await postActivityLog({
      menu_path: "HIMO Billing-Digos Water District-Zone Settings",
      sub_menu_path: "/zone-settings/zones",
      action: `Delete Zone Type (ID ${id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    if (response.status === 204) {
      return null
    }

    const contentType = response.headers.get("content-type")
    if (contentType && contentType.includes("application/json")) {
      return response.json()
    } else {
      return null
    }
  }

  return null
}
